import type { DebugMaterialMode } from '../debug/debug-materials'

export class DebugLegendHUD {
  private readonly container: HTMLDivElement
  private readonly modeLabel: HTMLSpanElement
  private readonly camLabel: HTMLSpanElement
  private readonly coordLabel: HTMLDivElement

  constructor() {
    this.container = document.createElement('div')
    this.container.id = 'debug-legend-hud'
    this.container.style.position = 'fixed'
    this.container.style.top = '12px'
    this.container.style.left = '12px'
    this.container.style.backgroundColor = 'rgba(10, 14, 20, 0.88)'
    this.container.style.border = '1px solid rgba(0, 240, 255, 0.4)'
    this.container.style.borderRadius = '4px'
    this.container.style.padding = '10px 14px'
    this.container.style.fontFamily = 'monospace'
    this.container.style.fontSize = '12px'
    this.container.style.color = '#e0e8f0'
    this.container.style.zIndex = '9999'
    this.container.style.pointerEvents = 'none'
    this.container.style.lineHeight = '1.5'
    this.container.style.boxShadow = '0 4px 16px rgba(0,0,0,0.6)'

    this.container.innerHTML = `
      <div style="font-weight: bold; color: #00f0ff; margin-bottom: 4px; letter-spacing: 1px;">
        ⚙ DIAGNOSTIC SCHEMATIC OVERLAY
      </div>
      <div style="margin-bottom: 2px;">
        <span style="color: #88a0b8;">[F1 / M] Shaders:</span> <span id="debug-mode-text" style="color: #ffff00; font-weight: bold;">AUTHENTIC</span>
      </div>
      <div style="margin-bottom: 6px;">
        <span style="color: #88a0b8;">[F2 / O] Camera:</span> <span id="debug-cam-text" style="color: #00ff88; font-weight: bold;">PERSPECTIVE</span>
      </div>
      <div id="debug-coords-text" style="color: #79c0ff; margin-bottom: 8px; font-size: 11px;">
        POS: X: 0.00 | Y: 0.00 | Z: 0.00
      </div>
      <div style="font-size: 11px; border-top: 1px solid rgba(255,255,255,0.1); padding-top: 6px; display: grid; grid-template-columns: 1fr 1fr; gap: 4px 12px;">
        <div><span style="display:inline-block;width:10px;height:10px;background:#3d5a80;border:1px solid #778;margin-right:4px;vertical-align:middle;"></span>Wall</div>
        <div><span style="display:inline-block;width:10px;height:10px;background:#52796f;border:1px solid #778;margin-right:4px;vertical-align:middle;"></span>Floor</div>
        <div><span style="display:inline-block;width:10px;height:10px;background:#ff007f;margin-right:4px;vertical-align:middle;"></span>Door</div>
        <div><span style="display:inline-block;width:10px;height:10px;background:#00e5ff;margin-right:4px;vertical-align:middle;"></span>Elevator</div>
        <div><span style="display:inline-block;width:10px;height:10px;background:#ff9800;margin-right:4px;vertical-align:middle;"></span>Crate</div>
        <div><span style="display:inline-block;width:10px;height:10px;background:#ff1744;margin-right:4px;vertical-align:middle;"></span>Target</div>
      </div>
    `

    document.body.appendChild(this.container)
    this.modeLabel = this.container.querySelector('#debug-mode-text')!
    this.camLabel = this.container.querySelector('#debug-cam-text')!
    this.coordLabel = this.container.querySelector('#debug-coords-text')!
  }

  update(mode: DebugMaterialMode, isSchematic: boolean, playerX: number, playerY: number, playerZ: number) {
    const modeNames: Record<DebugMaterialMode, string> = {
      authentic: 'AUTHENTIC_1998',
      type_colors: 'TYPE_COLORS',
      mesh_normals: 'FACE_NORMALS',
      wireframe_normals: 'WIREFRAME_NORMALS',
      uv_grid: 'UV_GRID_CHECKER',
    }
    this.modeLabel.textContent = modeNames[mode]
    this.modeLabel.style.color = mode === 'authentic' ? '#88ccff' : mode === 'uv_grid' ? '#00f0ff' : mode === 'mesh_normals' ? '#ff00ff' : '#ffff00'

    this.camLabel.textContent = isSchematic ? 'TOP_DOWN_ORTHO' : 'PERSPECTIVE'
    this.camLabel.style.color = isSchematic ? '#00ffff' : '#00ff88'

    this.coordLabel.textContent = `POS: X: ${playerX.toFixed(2)} | Y: ${playerY.toFixed(2)} | Z: ${playerZ.toFixed(2)}`
  }

  setVisible(visible: boolean) {
    this.container.style.display = visible ? 'block' : 'none'
  }
}
